import { render, staticRenderFns } from "./VaultCheckersQueue.vue?vue&type=template&id=01de490e&"
import script from "./VaultCheckersQueue.vue?vue&type=script&lang=js&"
export * from "./VaultCheckersQueue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports